<div
  (click)="onClick()"
  (keydown)="onKeyDown($event)"
  tabindex="0"
  [class]="containerClasses"
>
  <span [class]="textClasses" #text>
    <ng-content></ng-content>
  </span>
</div>
